import ImageCarousel from './image-carousel'
export default ImageCarousel
